// extracted by mini-css-extract-plugin
module.exports = {"square":"ParameterGraph_square__3sEz0","stockingName":"ParameterGraph_stockingName__2_H8V"};